import type { T } from '@deltachat/jsonrpc-client'

/**
 * The type the message will have *after* it is downloaded. It's a fork-only
 * field on the pre-message placeholder that upstream's generated jsonrpc
 * bindings don't declare yet (core regenerates them later in the build), so we
 * read it through this one typed accessor.
 *
 * ponytail: single typed cast lives here instead of scattering `as any` at call
 * sites; drop the cast once the regenerated bindings carry `postMessageViewType`.
 */
export function getPostMessageViewType(message: T.Message): T.Viewtype | null {
  const viewType =
    (message as { postMessageViewType?: T.Viewtype | null })
      .postMessageViewType ?? null
  // 'Unknown' would fall through to a nameless generic card; the plain-text
  // fallback line is strictly better for it.
  return viewType === 'Unknown' ? null : viewType
}

// Core appends " [Label – 123 KiB]" to the placeholder text (message.rs:645-674,
// bracketed, with an en-dash before the size). Strip that trailing tag so our
// own UI shows the size instead of duplicating it in the caption.
//
// ponytail: regex on the bracket/en-dash shape; known ceiling: a File tag whose
// filename itself contains "[" or "]" is not stripped (caption then shows the
// tag next to our size chip - cosmetic). Upgrade path = a core field carrying
// the raw caption without the appended tag.
const DOWNLOAD_TAG_RE = /\s*\[[^\]]*–[^\]]*\]\s*$/

export function placeholderCaption(text: string | null | undefined): string {
  return (text ?? '').replace(DOWNLOAD_TAG_RE, '').trim()
}
